/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront';
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore(value) {
    if (!('Url' in value) || value['Url'] === undefined)
        return false;
    if (!('StoreFront' in value) || value['StoreFront'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Url': json['url'],
        'StoreFront': FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontFromJSON(json['store_front']),
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['Url'],
        'store_front': FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontToJSON(value['StoreFront']),
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore.js.map